import { formatPhoneNumber } from "@phone/phoneSetupClient";
import { PHONE_MESSAGE, type Task } from "@tasks/tasksClient";

const written = (value: unknown): string | null =>
  typeof value === "string" && value.trim() !== "" ? value.trim() : null;

/** Mirrors brian's `take_message` payload (modules/agent/tools/phone.py). */
interface PhoneMessage {
  message: string | null;
  callerName: string | null;
  callbackNumber: string | null;
  patientName: string | null;
}

const phoneMessageOf = (task: Task): PhoneMessage | null => {
  if (task.kind !== PHONE_MESSAGE) return null;
  if (typeof task.payload !== "object" || task.payload === null) return null;
  const fields = task.payload as Record<string, unknown>;
  const callback =
    written(fields.callback_number) ?? written(fields.caller_number);
  return {
    message: written(fields.message),
    callerName: written(fields.caller_name),
    callbackNumber: callback ? formatPhoneNumber(callback) : null,
    patientName: written(fields.patient_name),
  };
};

export const todoDetail = (task: Task): string | null => {
  const phone = phoneMessageOf(task);
  if (phone)
    return (
      [phone.message, phone.callbackNumber].filter(Boolean).join("\n") || null
    );
  return written(task.details);
};

export const isCallback = (task: Task): boolean => task.kind === PHONE_MESSAGE;

export const callbackLabel = (task: Task): string => {
  const phone = phoneMessageOf(task);
  const label = [phone?.callerName ?? phone?.callbackNumber, phone?.patientName]
    .filter(Boolean)
    .join(" · ");
  return label || task.title;
};
